import styled from 'styled-components';

const CouponModalStyled = styled.div`
  width: 1000px;
  .coupon-name-wrap {
    /* width: 100%; */
    height: 40px;
    display: flex;
    padding-right: 24px;
    justify-content: flex-end;
  }
  .coupon-name {
    width: 261px;
  }
  .table-header {
    width: 100%;
  }
  .coupon-list {
    width: 100%;
    height: 680px;
    overflow-y: scroll;
  }
  .modal-btn-wrap {
    margin-right: ${(props) => props.theme.spacing(3)};
    display: flex;
    flex-direction: row;
    float: right;
    /* margin-bottom:35px; */
    gap: 6px;
    /* margin-top: ${(props) => props.theme.spacing(23 / 8)}; */

    margin-bottom: ${(props) => props.theme.spacing(36 / 8)};
  }
`;

export default CouponModalStyled;
